export default {
    searchHint: 'Δοκίμασε άλλους όρους αναζήτησης.',
    filtersHint: 'Δοκίμασε άλλους όρους αναζήτησης ή άλλαξε τα φίλτρα.'
}
